
import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    Card,
    message,
    Input,
    Switch,
    Button,
    Form,
    Modal,
    Checkbox,
    InputNumber,
    ColorPicker,
    Select,
    Badge,

} from "../../ui/ot";

import { useHashTag } from "../controllers/HashTagController";
import { ClassifyStructure } from "../../ui/ot";
import { useCategory } from "../controllers/category_controller";
const MediaContent = ({
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    propsClassifyStructureTypeId = 0,
    propsClassifyStructureId = 1,
    propsRowSelectionMode,
    propsOnValuesChange = () => { },
    propsShowKeys = [
        { key: "font_color", name: "font_color", hidden: false, require: false },
        { key: "background_color", name: "background_color", hidden: false, require: false },
        { key: "hashtag_arr", name: "hashtag_arr", hidden: false, require: false },
        { key: "category_arr", name: "category_arr", hidden: false, require: false },
    ],
    propsDeleteModal = false
}) => {
    const actionRef = useRef(null);
    const modalRef = useRef(null);
    const columns = [
        {
            title: "名稱",
            dataIndex: "title",
            key: "title",
            width: "100px",
            render: (text, record, index) => {
                return text
            }
        },
        {
            title: "標籤",
            dataIndex: "hashtag_data",
            key: "hashtag_data",
            width: "100px",
            render: (text, record, index) => {
                let hashtag_datas = record?.hashtag_data || []
                return hashtag_datas.map((hashtag_data) => {
                    return <Badge>
                        {hashtag_data?.hashtag_name}
                    </Badge>
                })
            }
        },
        {
            title: "分類",
            dataIndex: "category_data",
            key: "category_data",
            width: "100px",
            render: (text, record, index) => {
                let category_datas = record?.category_data || []
                return category_datas.map((category_data) => {
                    return <Badge>
                        {category_data?.category_name}
                    </Badge>
                })
            }
        },
        // {
        //     title: "建立人",
        //     key: "upload_user_name",
        //     dataIndex: "upload_user_name",
        // },
        // {
        //     title: "最後編輯人",
        //     key: "last_edit_user_name",
        //     dataIndex: "last_edit_user_name",
        // },
        // {
        //     title: "最後編輯時間",
        //     dataIndex: "last_edit_time",
        //     key: "last_edit_time",
        // },
        // {
        //     title: "操作",
        //     key: "option",
        //     sorter: false,
        //     disabled: true,
        //     render: (text, record, _index) => {
        //         return (
        //             <Row wrap={false} gutter={[8, 8]}>
        //                 <Col>
        //                     <Button
        //                         onClick={() => {
        //                             modalRef.current.handleModalOpen(true);
        //                             setAxiosMethod("patch");
        //                             modalRef.current.setFormValues({
        //                                 ...record,
        //                             });
        //                         }}
        //                     >
        //                         編輯
        //                     </Button>
        //                 </Col>
        //                 <Col>
        //                     <DeletePopHover
        //                         onConfirm={() => {
        //                             deleteCategoryData([
        //                                 {
        //                                     category_id: record?.category_id,
        //                                 },
        //                             ]);
        //                         }}
        //                         onCancel={() => { }}
        //                     />
        //                 </Col>
        //             </Row>
        //         );
        //     },
        // },
    ];
    const [form] = Form.useForm();
    const [count, setCount] = useState(0)

    const [axiosMethod, setAxiosMethod] = useState("post");
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };

    const formItemsRender = (fieldName = "", formValues, onValuesChange = () => { }, propsCustomForm, field, propsShowKeys) => {
        return (
            <Row>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_id"}
                        name={[fieldName ?? '', "classify_structure_id"]}
                    >
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_type_parent_id"}
                        name={[fieldName ?? '', "classify_structure_type_parent_id"]}
                    >
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_type_id"}
                        name={[fieldName ?? '', "classify_structure_type_id"]}
                    >
                    </Form.Item>
                </Col>
                <Col span={24}
                    hidden={propsShowKeys?.find((element) => {
                        return element.name === "font_color"
                    })?.hidden}>
                    <Form.Item
                        label={"文字顏色"}
                        name={[fieldName ?? '', "font_color"]}
                    >
                        <ColorPicker
                            format={"hex"}
                            onChange={(e) => {
                                let property_json = getAnyFormValue([fieldName ?? '', "property_json"], count)
                                setFieldValue([fieldName ?? '', "property_json"], {
                                    ...property_json,
                                    background_color1: e.target.value
                                })
                                setCount(pre => pre + 1)

                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}
                    hidden={propsShowKeys?.find((element) => {
                        return element.name === "background_color"
                    })?.hidden}>
                    <Form.Item
                        label={"資料夾顏色"}
                        name={"background_color"}
                    >
                        <ColorPicker
                            format={"hex"}
                            // value={colorData?.background_color2}
                            onChange={(e) => {
                                let property_json = getAnyFormValue([fieldName ?? '', "property_json"], count)
                                setFieldValue([fieldName ?? '', "property_json"], {
                                    ...property_json,
                                    background_color2: e.target.value
                                })
                                setCount(pre => pre + 1)
                            }}
                        ></ColorPicker>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Row gutter={[8, 16]} align="middle">
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "hashtag_arr"
                            })?.hidden}>
                            <Form.Item
                                label={"標籤"}
                                name={[fieldName ?? '', "hashtag_arr"]}
                            >
                                <Select
                                    mode={"multiple"}
                                    // value={getAnyFormValue('permission_page_data.0.page_id', count) || null}
                                    options={
                                        (HashTagData || []).map((val) => {
                                            return {
                                                label: val?.tag_name,
                                                value: val?.tag_id
                                            }
                                        })
                                    }
                                /></Form.Item>
                        </Col>
                        <Col span={24}>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row gutter={[8, 16]} align="middle">
                        <Col span={24}>
                            <Form.Item
                                label={"分類"}
                                name={[fieldName ?? '', "category_arr"]}

                                hidden={propsShowKeys?.find((element) => {
                                    return element.name === "category_arr"
                                })?.hidden}>
                                <Select
                                    mode={"multiple"}
                                    name={"category_data"}
                                    // value={getAnyFormValue('permission_page_data.0.page_id', count) || null}
                                    options={
                                        (CategoryData || []).map((val) => {
                                            return {
                                                label: val?.category_name,
                                                value: val?.category_id
                                            }
                                        })
                                    }
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </Col>
            </Row>
        );
    };
    const reorganizeFormData = (formValues, type) => {
        if (type === 'set') {
            let classify_structure_id_temp = formValues?.classify_structure_id
            let classify_structure_id = classify_structure_id_temp
            let hashtag_arr = (formValues?.hashtag_data || []).map((hash_tag) => {
                return hash_tag?.hashtag_id
            })
            let category_arr = (formValues?.category_data || []).map((category) => {
                return category?.category_id
            })
            if (isJSON(classify_structure_id_temp)) {
                classify_structure_id_temp = JSON.parse(classify_structure_id_temp)
                if (Array.isArray(classify_structure_id_temp)) {
                    classify_structure_id = classify_structure_id_temp.find((e) => true)
                }
            }
            return {
                ...formValues,
                classify_structure_id,
                hashtag_arr,
                category_arr
            }
        }
        else if (type === "submit") {
            let classify_structure_id = propsClassifyStructureId
            let classify_structure_type_id = propsClassifyStructureTypeId
            let hashtag_data = (formValues?.hashtag_arr || []).map((hash_tag) => {
                return {
                    hashtag_id: hash_tag
                }
            })
            let category_data = (formValues?.category_arr || []).map((category) => {
                return {
                    category_id: category
                }
            })
            if (isJSON(propsClassifyStructureId)) {
                let classify_structure_id_temp = JSON.parse(propsClassifyStructureId)
                if (Array.isArray(classify_structure_id_temp)) {
                    classify_structure_id = classify_structure_id_temp.find((e) => true)
                }
            }
            return {
                ...formValues,
                classify_structure_type_id,
                classify_structure_id,
                hashtag_data,
                category_data
            }
        }

    }
    function isJSON(str) {
        try {
            JSON.parse(str)
            return true;
        } catch (e) {
            return false;
        }
    }

    const {
        HashTagData,
        getHashTagData,
    } = useHashTag({
        onFinish: () => { },
        onBefore: () => { },
    });
    const {
        getCategoryData,
        CategoryData
    } = useCategory({

    })
    useEffect(() => {
        getCategoryData({})
        getHashTagData({})
    }, [])
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ClassifyStructure
                    reorganizeFormData={reorganizeFormData}
                    prefixTitle={'classify_structure_type'}
                    customColumns={columns}
                    rowSelectionMode={propsRowSelectionMode}
                    classify_structure_type_id={propsClassifyStructureTypeId}
                    multipleClassifyStructure
                    classify_structure_id_arr={JSON.stringify([propsClassifyStructureId])}
                    apiRoute={"/media_classification_storage/api/classify/type/folder"}
                    customFormItems={(fieldName, formValues, onValuesChange = () => { }, propsCustomForm, field) => {
                        return formItemsRender(fieldName, formValues, onValuesChange = () => { }, propsCustomForm, field, propsShowKeys);
                    }}
                    onSelectChange={propsOnValuesChange}
                    defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                    defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                    propsDeleteModal={propsDeleteModal}
                />
            </Col>
        </Row>
    );
};

export default MediaContent;
